.r{align-items:center;}